// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"95743ecf","238":"15d5c982","393":"e2caca47","498":"9be80c71","513":"104f06cb","532":"bc4ffbcc","555":"afc1718c","567":"729350f0","570":"d48b9d2d","573":"06b3a26f","663":"edee56f3","726":"ad8f1e8b","752":"7904daa8","753":"c8edc8d9","971":"9b94676b"}[chunkId] + ".chunk.js";
};